import type { PropsWithChildren } from 'react'
import { useState } from 'react'
import { TooltipProvider } from '@cocoonspace/ui/components/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// @ts-expect-error - LucideProvider is not exported ?
import { LucideProvider } from 'lucide-react'
import { NuqsAdapter } from 'nuqs/adapters/next/app'

import { analytics } from '~/lib/analytics'
import { CartProvider } from '../domains/cart/cart-provider'
import { AuthProvider } from './auth-provider'
import { AxeptioProvider } from './axeptio-provider'
import { TrackingProvider } from './tracking-provider'
import { UserProvider } from './user-provider'

export const Providers = ({ children }: PropsWithChildren) => {
	const [queryClient] = useState(() => new QueryClient())

	return (
		<LucideProvider
			size={16}
			strokeWidth={1.5}
		>
			<NuqsAdapter>
				<QueryClientProvider client={queryClient}>
					<AuthProvider>
						<TrackingProvider instance={analytics}>
							<AxeptioProvider
								clientId={process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_ID as string}
							>
								<UserProvider>
									<CartProvider>
										<TooltipProvider delayDuration={300}>
											{children}
										</TooltipProvider>
									</CartProvider>
								</UserProvider>
							</AxeptioProvider>
						</TrackingProvider>
					</AuthProvider>

					<ReactQueryDevtools buttonPosition='bottom-left' />
				</QueryClientProvider>
			</NuqsAdapter>
		</LucideProvider>
	)
}
